module.exports = __webpack_public_path__ + "media/anruf_konrad_1.b44ebac1.mp3";